import { useEffect, useRef, useState } from "react";
import { connect, useStore } from "react-redux";
import useMedia from 'use-media';
import { ModalClose } from "../../atoms/modalClose";
// import image_base from '../../../resources/image/GrandeeHamanako.jpg';
import "./../../../resources_membership_hotel/css/esthetic/restaurantListModal.css"
import { Button } from "../../atoms/button";
import { Link, useHistory } from "react-router-dom";
import Const from "../../../const/Const";
import messageConst from "../../../const/messageConst";

const RestaurantListDetailPopupContainer = (props) => {
    const {
        login,
        state,
        resvKaiinken,
        setPopupMode,
        setPopupMessage,
        setRestaurantInfo,
        onClickOpenPopupWindow,
        onClickOpenMessageWindow,
        onClickClosePopupWindow,
        setKaiinkenFlg
    } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });

    const history = useHistory();
    const popupData = state.popupData;
    const popupRestaurant = state.popupRestaurant;

    // 「予約する」ボタン押下
    const handleReserve = () => {
        const memberInfo = login?.memberInfo;
        let keiyakuNo = "";
        let riyoKaiinkenSyubetCd = "";
        let shisetsuFlg = false;
        resvKaiinken.forEach((data) => {
            if (data.selected) {
                keiyakuNo = data.keiyakuNo;
                riyoKaiinkenSyubetCd = data.riyoKaiinkenSyubetCd;
                if (!popupRestaurant.membershipFlg) {
                // if (!popupRestaurant.membershipFlg || (data.sisetuCd == popupData.shisetsuCd)) {
                    shisetsuFlg = true;
                }
                return;
            }
        })
        let messageFlg = true;
        if (memberInfo) {
            memberInfo.forEach(member => {
                member?.memberList?.data?.kaiinInfoList?.forEach(kaiinInfo => {
                    if (kaiinInfo?.bccKeiyakuKbn != 1 && kaiinInfo?.kaihiMinoKbn != 1) {
                        if (keiyakuNo == Const.GENERAL_CONTRACT_NO) {
                            keiyakuNo = kaiinInfo.keiyakuNo
                        }
                        messageFlg = false;
                        return;
                    }
                })
                if (!messageFlg) {
                    return;
                }
            });
        } else if (shisetsuFlg) {
            messageFlg = false;
        }
        // setKaiinkenFlg(messageFlg || !shisetsuFlg);
        setKaiinkenFlg(messageFlg);
        // if (!messageFlg && shisetsuFlg) {
        if (!messageFlg) {
            setRestaurantInfo({
                honkanShisetsuCd: popupData.honkanShisetsuCd,
                shisetsuCd: popupData.shisetsuCd,
                shisetsuName: popupData.shisetsuName,
                restaurantCd: popupRestaurant.restaurantCd,
                restaurantName: popupRestaurant.restaurantName,
                keiyakuNo: keiyakuNo,
                riyoKaiinkenSyubetCd: riyoKaiinkenSyubetCd,
                memberCd: resvKaiinken[0].memberCd,
            });
            history.push("/reserve/hotel/restaurantReserve");
        } else {
            onClickClosePopupWindow("restaurantPopup");
        }
    }

    return (
        <div className={state.restaurantPopup ? "popupIsShow" : "popup"} id="js-popup">
            <div className={isWidePhone ? "bookConfirm inputUserPopupInner_media" : "bookConfirm inputUserPopupInner"}>
                <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={onClickClosePopupWindow} />
                <h4 className="popupInnerText" >{"レストラン詳細"}</h4>
                <div className="listDetailPopupImgWrap" >
                    <img src={popupRestaurant.restaurantImagePath} alt="" className="listDetailPopupImg" /> 
                </div>

                <div className="listDetailPopupInfo">
                    <div className="popupShisetsuName">{popupData && popupData.shisetsuName ? popupData.shisetsuName : ""}</div>
                    <div className="popupShisetsuName">{popupRestaurant && popupRestaurant.restaurantName ? popupRestaurant.restaurantName : ""}</div>
                </div>
                <div className="listDetailPopupInfo">
                    <div className="popupStoreInfoTitle">店舗説明</div>
                    <p className="popupStoreInfo">{popupRestaurant && popupRestaurant.tenpoSetsumei ? popupRestaurant.tenpoSetsumei : ""}</p>
                    <p className="popupStoreInfoURL">{popupRestaurant && popupRestaurant.tenpoSetsumeiURL ? <a href={popupRestaurant.tenpoSetsumeiURL} target="_blank" rel="noopener noreferrer"> {popupRestaurant.tenpoSetsumeiURL} </a>: ""}</p>
                </div>
                {login.memberCode ?
                    <div className="buttonArea buttonAreaSticky">
                        <Button
                            buttonText="予約する"
                            className="popupBtnReservationResult"
                            onClick={() => handleReserve()}
                            buttonClassName="serachBtnText"
                            tabIndex="18"
                        />
                    </div>
                    : null
                }
            </div>
            <div className="blackBackground" id="js-black-bg"></div>
        </div >
    );
};

const mapStateToProps = (state) => {
    return {
        login: state.login,
        resvKaiinken: state.resvKaiinken,
        restaurant: state.restaurant,
        mealTime: state.mealTime,
        course: state.course,
        mealInfoList: state.mealInfoList
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setMealInfoList: (item) => {
            dispatch({ type: "MEAL_INFO_LIST", payload: { mealInfoList: item } })
        },
        setRestaurantInfo: (item) => {
            dispatch({ type: "RESTAURANT_INFO", payload: { restaurantInfo: item } })
        },
        setMealTime: (item) => {
            dispatch({ type: "MEAL_TIME", payload: { mealTime: item } })
        },
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(RestaurantListDetailPopupContainer);
